import { createAction } from '@reduxjs/toolkit';

export const accountCleared = createAction('session/accountCleared');
